<template>
    <svg class="IconFlowGraphContain" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
            d="M5.417,18.209a2.917,2.917,0,1,1,2.8-3.75h4.7V12.793h1.667v-4.8L12.714,6.126h-4.8V7.793h-5v-5h5V4.459h4.8l2.7-2.7,3.536,3.537-2.7,2.7v4.8h1.667v5h-5V16.126h-4.7a2.918,2.918,0,0,1-2.8,2.083Zm0-4.167a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,5.417,14.043Zm10.833.417H14.583v1.667H16.25ZM15.417,4.114,14.238,5.293l1.178,1.178,1.178-1.178ZM6.25,4.459H4.583V6.126H6.25Z"
            transform="translate(-0.417 -0.293)"
            :fill="color"
        />
    </svg>
</template>

<script>
import IconBase from '@/components/icons/IconBase'

export default {
    name: 'IconFlowGraphContain',
    extends: IconBase
}
</script>

<style scoped lang="scss">

</style>
